import { useEffect, useState } from "react";

/**
 * Menunda pembaruan nilai sampai tidak ada perubahan lagi selama `delay` ms.
 *
 * Dipakai untuk search-as-you-type: sekarang banyak halaman pencarian baru
 * menembak API setelah pengguna menekan Enter. Dengan hook ini, cukup
 * debounce nilai input lalu pakai hasilnya sebagai dependency `useEffect`
 * (atau `queryKey` di `useDataQuery`) — API ditembak begitu ketikan "diam",
 * tanpa menunggu Enter dan tanpa menembak di setiap tekan tombol.
 *
 * Contoh:
 *   const [q, setQ] = useState("");
 *   const qDebounced = useDebounce(q, 400);
 *   useEffect(() => { api.get("/produk", { params: { q: qDebounced } })...
 *   }, [qDebounced]);
 *
 * @param {*} nilai - nilai yang berubah cepat (mis. teks kotak pencarian)
 * @param {number} delay - jeda ms sebelum nilai "settle" diteruskan (default 400ms)
 * @returns nilai yang sudah didebounce
 */
export function useDebounce(nilai, delay = 400) {
  const [debounced, setDebounced] = useState(nilai);

  useEffect(() => {
    const timer = setTimeout(() => setDebounced(nilai), delay);
    return () => clearTimeout(timer);
  }, [nilai, delay]);

  return debounced;
}

export default useDebounce;
